var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourse01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 92,
    viewBox: "0 0 111 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_158_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.68 50.5168C25.5968 49.0695 27.1907 48.1924 28.9039 48.1924H77.8521C79.3121 48.1924 80.6991 48.8305 81.6491 49.9392L94.929 65.4392C97.708 68.6828 95.4032 73.6924 91.132 73.6924H19.0858C15.1451 73.6924 12.7532 69.3459 14.8619 66.0168L24.68 50.5168Z",
    fill: "#7B1FFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6384 11.2967L36.6384 11.2968L36.6429 11.2988L43.0038 14.0954C41.7533 15.9847 41.1011 18.1435 41.1011 20.4104C41.1011 26.7124 46.2212 31.8889 52.5796 31.8889C58.9376 31.8889 64.058 26.7685 64.058 20.4104C64.058 18.1989 63.4062 15.9874 62.2086 14.149L67.6509 11.5879V22.2288L65.9313 25.8898L65.9311 25.8898L65.9289 25.8952C65.8092 26.1945 65.8026 26.5132 65.9976 26.7732C66.1797 27.0161 66.4861 27.2037 66.8027 27.2037H70.0935C70.3908 27.2037 70.7148 27.0851 70.8506 26.7626C71.0376 26.5046 71.0295 26.1905 70.9114 25.8952L70.9112 25.8945L69.4126 22.2314V10.7053C69.4126 10.4803 69.3996 10.2602 69.2723 10.0533C69.1452 9.84668 68.9143 9.66877 68.5154 9.49782L68.5155 9.4975L68.5076 9.49486C68.5092 9.49538 68.5066 9.4945 68.4955 9.48988L68.4561 9.4732C68.4225 9.45881 68.3749 9.43823 68.3142 9.4118C68.1928 9.35897 68.0196 9.28307 67.8019 9.18738C67.3666 8.99601 66.7537 8.72566 66.023 8.40277C64.5615 7.757 62.6285 6.90119 60.7007 6.04711C58.773 5.19303 56.8504 4.34069 55.4098 3.70188L53.67 2.93026L53.1828 2.7142L53.0546 2.65729L53.0217 2.6427L53.0133 2.639L53.0126 2.63868C52.7627 2.51446 52.508 2.51445 52.2581 2.63866L36.6443 9.55336C36.3255 9.68187 36.0812 10.0546 36.0812 10.4264C36.0812 10.8004 36.2713 11.1131 36.6384 11.2967ZM62.129 20.4104C62.129 25.7098 57.8231 30.0156 52.5238 30.0156C47.2244 30.0156 42.9186 25.7098 42.9186 20.4104C42.9186 18.3967 43.5627 16.4891 44.694 14.8464L52.2021 18.214C52.3343 18.2794 52.4655 18.2794 52.5728 18.2794L52.5796 18.2794L52.5863 18.2794C52.6936 18.2794 52.8248 18.2794 52.9569 18.214L60.3551 14.9014C61.5377 16.5426 62.129 18.4493 62.129 20.4104ZM68.6629 25.3304H68.2425L68.4689 24.8453L68.6629 25.3304ZM39.3278 10.4264L52.6353 4.51191L65.9429 10.4264L52.6353 16.3409L39.3278 10.4264Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8584 33.6969C41.9267 33.6969 33.0134 42.6102 33.0134 53.5419C33.0134 54.0433 33.4486 54.4785 33.9501 54.4785H71.7668C72.2682 54.4785 72.7034 54.0433 72.7034 53.5419C72.7034 42.6102 63.7901 33.6969 52.8584 33.6969ZM70.825 52.6052H34.9475C35.4438 43.1139 43.298 35.5702 52.9142 35.5702C62.5296 35.5702 70.3289 43.1683 70.825 52.6052Z",
    fill: "black",
    stroke: "#0D0D0D",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_158_8",
    x: 0.0777588,
    y: 38.1924,
    width: 110.064,
    height: 53.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458333 0 0 0 0 0.458333 0 0 0 0 0.458333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_8",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse01);
export default __webpack_public_path__ + "static/media/course-01.86019c9272d8bc3be34a2bb6649b1ea8.svg";
export { ForwardRef as ReactComponent };